import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useProductStore } from '@elem/compPage/a-new-era-of-cool/ProductProvider';
import { IPageStatus } from '@elem/compPage/a-new-era-of-cool/config/IPageStatus';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import { useRouter } from 'next/router';

import styles from './index.module.scss';

export default function Comp({ title }: { title: string }) {
    const { t } = useLang('theProduct.HomeownersSection');
    const { locale } = useRouter();

    const { pageStatus } = useProductStore();

    const dataA: EcoBannerProps = {
        layout: 'center-center',
        title: title,
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
